import React, { useState, useEffect } from 'react';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import { useToast } from '../../components/ToastProvider';

const Profile = () => {
    const { customer, checkAuth, csrfToken } = useCustomerAuth();
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();

    useEffect(() => {
        if (customer) {
            setName(customer.name || '');
            setPhone(customer.phone || '');
        }
    }, [customer]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const BASE_URL = process.env.REACT_APP_API_BASE || 'https://handmade-haven.in';
            const res = await fetch(`${BASE_URL}/api/customer/update-profile.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                },
                body: JSON.stringify({ name, phone }),
                credentials: 'include'
            });
            const data = await res.json();

            if (data.ok) {
                showToast('Profile updated successfully!', 'success');
                checkAuth(); // Refresh context
            } else {
                showToast(data.message || 'Update failed', 'error');
            }
        } catch (err) {
            showToast('Something went wrong', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2 className="account-section-title">My Profile</h2>
            <form onSubmit={handleSubmit} style={{ maxWidth: '500px' }}>
                <div className="form-group">
                    <label>Email Address</label>
                    <input type="email" value={customer?.email || ''} disabled style={{ background: '#f9f9f9' }} />
                    <small className="otp-hint">Email cannot be changed</small>
                </div>
                <div className="form-group">
                    <label>Full Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Your Name"
                    />
                </div>
                <div className="form-group">
                    <label>Phone Number</label>
                    <input
                        type="text"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                        placeholder="10-digit mobile number"
                        maxLength={10}
                    />
                </div>
                <button type="submit" className="btn-login" disabled={loading} style={{ width: 'auto', padding: '12px 30px' }}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
            </form>
        </div>
    );
};

export default Profile;
